import React, { useCallback, useMemo, useState } from "react";
import styles from "./RenderPreview.module.scss";
import { DropDown } from "../../../../../../../shared/DropDown/DropDown";
import { useAppSelector } from "../../../../../../../redux/store";
import { getPreviewImageById } from "../../../../../../../redux/reducers/ui/selectors/imageProductSelectors";
import { getProcessObjectImageHash } from "../../../../../../../redux/reducers/ui/selectors/objectProcessSelectors";
import { Logo } from "../../../../../../../assets/svg/Logo";
import placeholder_img from "../../../../../../../assets/images/item_placeholder.png";

interface IRenderPreviewProps {
  productId: string;
}
export const RenderPreview: React.FC<IRenderPreviewProps> = props => {
  const { productId } = props;
  const previewImage = useAppSelector(getPreviewImageById(productId));

  const imageHashProcess = useAppSelector(getProcessObjectImageHash);

  // Show image if available, and overlay loader when rendering is in progress
  const showImage = !!previewImage;
  const showLoader = !!imageHashProcess;

  // Compute scaled preview size based on image aspect ratio
  const [previewSize, setPreviewSize] = useState<{
    w: number;
    h: number;
  } | null>(null);

  // Target size for the longer side in px
  const MAX_PREVIEW_SIDE = 100;

  const onImageLoad = useCallback(
    (e: React.SyntheticEvent<HTMLImageElement>) => {
      const img = e.currentTarget;
      const { naturalWidth, naturalHeight } = img;

      if (!naturalWidth || !naturalHeight) return;

      // Scale so that the longer side is fixed to MAX_PREVIEW_SIDE
      const k = MAX_PREVIEW_SIDE / Math.max(naturalWidth, naturalHeight);
      const w = Math.round(naturalWidth * k);
      const h = Math.round(naturalHeight * k);

      setPreviewSize({ w, h });
    },
    []
  );

  const previewStyle = useMemo(() => {
    if (!previewSize) return undefined;

    return {
      width: `${previewSize.w}px`,
      height: `${previewSize.h}px`,
    } as React.CSSProperties;
  }, [previewSize]);

  return (
    <DropDown title="Render preview" defaultOpen={true}>
      <div className={styles.preview_wrapper}>
        {!showLoader &&
          (showImage ? (
            <div className={styles.preview} style={previewStyle}>
              <img
                src={previewImage}
                alt="render_preview"
                onLoad={onImageLoad}
              />
            </div>
          ) : (
            <div className={styles.preview} style={previewStyle}>
              <img
                src={placeholder_img}
                alt="render_preview"
                onLoad={onImageLoad}
              />
            </div>
          ))}

        {showLoader && (
          <div className={styles.render_process}>
            <div className={styles.icon}>
              <Logo />
            </div>
            <div className={styles.text_process}>
              Rendering in progress…
              <br />
              Please try again later.
            </div>
          </div>
        )}
      </div>
    </DropDown>
  );
};
